import { getOrderSeatsForShowtime } from './get-order-seats-for-showtime';
export const getOrderSeatCountPerAreaCategory = (showtimeId) => {
    return getOrderSeatsForShowtime(showtimeId).reduce((acc, seat) => {
        const { areaCategoryId } = seat;
        const previousCount = acc.get(areaCategoryId) || 0;
        return acc.set(areaCategoryId, previousCount + 1);
    }, new Map());
};
